import React, { useEffect, useState } from 'react'
import api from '../components/api';
import { dataTableRender, fmtMoney, cor, corEnviado, rotulo, rotuloEnviado } from '../components/functions'
import ModalEnergia from '../modals/energia'


const TabelaGestao = (props) => {

    var adesao_institucional_id = props.adesao_institucional_id
    var [resultadoEnergia, setResultadoEnergia] = useState()
    var [ano, setAno] = useState()

    var [tabela, setTabela] = useState('gestaoPendencias')
    
    var [tabelaConsumoCombustiveis, setTabelaConsumoAnualCombustiveis] = useState()
    var [tabelaMercadoPredominante, setTabelaMercadoPredominante] = useState()
    var [tabelaConsumoCombustiveis, setTabelaConsumoCombustiveis] = useState()
    var [tabelaConsumoAnualCombustiveis, setTabelaConsumoAnualCombustiveis] = useState()
    var [tabelaConsumoEE, setTabelaConsumoEE] = useState()
    var [tabelaConsumoTotalEnergia, setTabelaConsumoTotalEnergia] = useState()
    var [tabelaCapacidadeInstalada, setTabelaCapacidadeInstalada] = useState()




    async function energia() {

        if (adesao_institucional_id) {


            api.get(`energiaTabelaGestao/${adesao_institucional_id}`).then((result) => {

                //console.log(result.data)

                setResultadoEnergia(result.data.map((rs) =>

                    <tr data-toggle="modal" style={{cursor: 'pointer', display: rs.secaoConsumo == null && rs.secaoEficiencia == null && rs.secaoPlanilha == null ? 'none' : 'table-row'   }} data-target="#modalEnergia" onClick={() => setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio)}>
                        <td><center>{rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio}</center></td>
                        <td style={{ backgroundColor: cor(rs.situacaoPerfilAnual)}}><center>{rotulo(rs.situacaoPerfilAnual)}</center></td>
                        <td style={{ backgroundColor: cor(rs.secaoConsumo)}} ><center>{rotulo(rs.secaoConsumo)}</center></td>
                        <td style={{ backgroundColor: cor(rs.secaoEficiencia)}} ><center>{rotulo(rs.secaoEficiencia)}</center></td>
                        <td style={{ backgroundColor: cor(rs.secaoPlanilha)}} ><center>{rotulo(rs.secaoPlanilha)}</center></td>
                        <td style={{ backgroundColor: corEnviado(rs.situacaoEnviado)}}><center>{rotuloEnviado(rs.situacaoEnviado)}</center></td>
                        <td ><center>{rs.dataEnvio}</center></td>

                    </tr>
                
                ))

                dataTableRender('dataTableExampleEnergia')


            }).catch((err) => {

                console.log(err.response)

            })

          

        }

    }


    async function carregaTabelasMonitoramento() {


        
        if (adesao_institucional_id) {


            api.get(`energiaTabelasMonitoramento/${adesao_institucional_id}`).then((result) => {

                console.log(result.data)

                setTabelaMercadoPredominante(result.data.map((rs) =>

                    <tr data-toggle="modal" style={{cursor: 'pointer'}} data-target="#modalEnergia" onClick={() => setAno(rs.ano)}>
                        <td><center>{rs.ano}</center></td>
                        <td><center>{rs.areaConstruida}</center></td>
                        <td><center>{rs.mercadoPredominante != null && rs.mercadoPredominante != 'null' ? rs.mercadoPredominante : ''}</center></td>
                        <td><center>{rs.consumoTotalEE}</center></td>
                        <td><div align="right">{rs.custoAnualEE != null & rs.custoAnualEE != '' ? fmtMoney(rs.custoAnualEE) : ''}</div></td>
                        <td><div align="right">{rs.custoFinalKWH != null & rs.custoFinalKWH != '' ? fmtMoney(rs.custoFinalKWH) : ''}</div></td>
                        
                        
                    </tr>
                
                ))

                dataTableRender('tabelaMercadoPredominante')

                setTabelaConsumoCombustiveis(result.data.map((rs) =>
                
                    <tr data-toggle="modal" style={{cursor: 'pointer'}} data-target="#modalEnergia" onClick={() => setAno(rs.ano)}>
                        <td><center>{rs.ano}</center></td>
                        <td><center>{rs.consumoAnualFosseis}</center></td>
                        <td><center>{rs.consumoAnualNaoFosseis}</center></td>
                        <td><div align="right">{rs.custoAnualCombustiveis != null & rs.custoAnualCombustiveis != '' ? fmtMoney(rs.custoAnualCombustiveis) : ''}</div></td>

                    </tr>
                
                ))

                setTabelaConsumoEE(result.data.map((rs) =>
                
                    <tr data-toggle="modal" style={{cursor: 'pointer'}} data-target="#modalEnergia" onClick={() => setAno(rs.ano)}>
                        <td><center>{rs.ano}</center></td>
                        <td><center>{rs.consumoEspecEletrTotalAnualEnergia}</center></td>
                        <td><center>{rs.consumoEspecEletrTotalAnualKwh}</center></td>
                        <td><center>{rs.formula1}</center></td>
                        <td><center>{rs.formula2}</center></td>
                    </tr>

                ))

                dataTableRender('tabelaConsumoEE')

                setTabelaConsumoAnualCombustiveis(result.data.map((rs) => 
                
                
                    <tr>
                        <td><center>{rs.ano}</center></td>
                        <td><center>{rs.consumoEspecEletrTotalAnualKjm}</center></td>
                        <td><center>{rs.consumoEspecFosseisKjm}</center></td>
                        <td><center>{rs.consumoEspecNaoFosseisKjm}</center></td>
                        <td><center>{rs.formula3}</center></td>
                        <td><center>{rs.formula4}</center></td>
                    </tr>
                
                ))

                dataTableRender('tabelaConsumoAnualCombustiveis')


                setTabelaConsumoTotalEnergia(result.data.map((rs) => 

                    <tr data-toggle="modal" style={{cursor: 'pointer'}} data-target="#modalEnergia" onClick={() => setAno(rs.ano)}>
                        <td><center>{rs.ano}</center></td>
                        <td><center>{rs.consumoTotalAnualEnergia}</center></td>
                        <td><center>{rs.consumoEspecTotalAnualEnergia}</center></td>
                        <td><center>{rs.formula5}</center></td>
                        <td><center>{rs.formula6}</center></td>
                    </tr>

                ))

                dataTableRender('tabelaConsumoTotalEnergia')

                setTabelaCapacidadeInstalada(result.data.map((rs) => 
                
                    <tr data-toggle="modal" style={{cursor: 'pointer'}} data-target="#modalEnergia" onClick={() => setAno(rs.ano)}>
                        <td><center>{rs.ano}</center></td>
                        <td><center>{rs.capacInstaladaFB}</center></td>
                        <td><center>{rs.capacInstaladaAuto}</center></td>
                    </tr>
                
                ))

                dataTableRender('tabelaCapacidadeInstalada')


            }).catch((err) => {

                console.log(err.response)

            })


        }
       


    }


    useEffect(() => {

        energia()
        carregaTabelasMonitoramento()

    }, [])

    return (

        <div>


                <div className="form-group" >
                    
                    <select className="form-control" onChange={event => setTabela(event.target.value)}>
                        <option value="gestaoPendencias">Tabela de gestão de pendências</option>
                        <option value="mercadoPredominante">Mercado Predominante</option>
                        <option value="consumoCombustiveis">Consumo de Combustíveis</option>
                        <option value="consumoEE">Consumo anual E. E.</option>
                        <option value="consumoAnualCombustiveis">Consumo anual de Combustíveis Fósseis</option>
                        <option value="consumoTotalEnergia">Consumo Total de Energia</option>
                        <option value="capacidadeInstalada">Capacidade Instalada em FV</option>
                        
                    </select>
                        

                </div>
            

            

                <div className="table-responsive" style={{ display: tabela == 'gestaoPendencias' ? 'block' : 'none' }}>
                    <table id="dataTableExampleEnergia" className="table table-bordered table-striped table-hover">
                        <thead>
                            <tr>
                                <th tyle={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Ano
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}> 

                                    <center>
                                    Form. Perfil Anual
                                    </center>

                                </th>
                               
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Dados de Consumo e Equipamentos
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Dados de Iniciativas de Ef. Energética
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Envio da Planilha de Dados
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Situação
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Data envio
                                    </center>

                                </th>
                                
                            </tr>
                            
                        </thead>
                        <tbody>
                            {resultadoEnergia}
                        </tbody>
                        
                    </table>
                
                </div>





                <div className="table-responsive" style={{ display: tabela == 'consumoCombustiveis' ? 'block' : 'none' }}>
                    <table id="tabelaConsumoCombustiveis" className="table table-bordered table-striped table-hover">
                    <thead>
                            <tr>
                                <th tyle={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Ano
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}> 

                                    <center>
                                    Cons. Comb. Fósseis (kJ)
                                    </center>

                                </th>
                               
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Cons. Comb. Não Fósseis (kJ)
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Custo Anual com Comb. (R$)
                                    </center>

                                </th>
                                
                                
                            </tr>
                            
                        </thead>
                        <tbody>

                            {tabelaConsumoCombustiveis}

                        </tbody>
                    </table>
                
                </div>


                <div className="table-responsive" style={{ display: tabela == 'mercadoPredominante' ? 'block' : 'none' }}>
                    <table id="tabelaMercadoPredominante" className="table table-bordered table-striped table-hover">
                    <thead>
                            <tr>
                                <th tyle={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Ano
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}> 

                                    <center>
                                    Área (m<sup>2</sup>)
                                    </center>

                                </th>
                               
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Mercado Predominante
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Consumo EE (kWh)
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Custo com EE (R$)
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Custo final do kWh (R$/kWh)
                                    </center>

                                </th>
                                
                            </tr>
                            
                        </thead>
                        <tbody>

                            {tabelaMercadoPredominante}

                        </tbody>
                    </table>
                
                </div>



                <div className="table-responsive" style={{ display: tabela == 'consumoEE' ? 'block' : 'none' }}>
                    <table id="tabelaConsumoEE" className="table table-bordered table-striped table-hover">
                        <thead>
                            <tr>
                                <th tyle={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Ano
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}> 

                                    <center>
                                    Cons. Anual EE (kWh/m²)
                                    </center>

                                </th>
                               
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Cons. Anual EE (kJ/m²)
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Cons. Anual EE (kJ/FTE)
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Cons. Anual EE (kJ/leito ocupado)
                                    </center>

                                </th>
                                
                                
                            </tr>
                            
                        </thead>
                        <tbody>
                            {tabelaConsumoEE}
                        </tbody>
                    </table>
                
                </div>



                <div className="table-responsive" style={{ display: tabela == 'consumoAnualCombustiveis' ? 'block' : 'none' }}>
                    <table id="tabelaConsumoAnualCombustiveis" className="table table-bordered table-striped table-hover">
                        <thead>
                            <tr>
                                <th tyle={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Ano
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}> 

                                    <center>
                                    Cons. Anual de Comb. Fósseis (kJ/m²)
                                    </center>

                                </th>
                               
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Cons. Anual de Comb. Não Fósseis (kJ/m²)
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Cons. Anual de Comb. (kJ/m²)
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Cons. Anual de Comb. (kJ/FTE)
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Cons. Anual de Comb. (kJ/leito ocupado)
                                    </center>

                                </th>
                                
                                
                                
                            </tr>
                            
                        </thead>
                        <tbody>

                            {tabelaConsumoAnualCombustiveis}

                        </tbody>
                    </table>
                
                </div>



                <div className="table-responsive" style={{ display: tabela == 'consumoTotalEnergia' ? 'block' : 'none' }}>
                    <table id="tabelaConsumoTotalEnergia" className="table table-bordered table-striped table-hover">
                    <thead>
                            <tr>
                                <th tyle={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Ano
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}> 

                                    <center>
                                    Cons. Total de Energia (kJ)

                                    </center>

                                </th>
                               
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Cons. Total de Energia (kJ/m²)
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Cons. Total de Energia (kJ/FTE)
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Cons. Total de Energia (kJ/leito ocupado)
                                    </center>

                                </th>
                                
                                
                                
                            </tr>
                            
                        </thead>
                        <tbody>

                            {tabelaConsumoTotalEnergia}

                        </tbody>
                    </table>
                
                </div>



                <div className="table-responsive" style={{ display: tabela == 'capacidadeInstalada' ? 'block' : 'none' }}>
                    <table id="tabelaCapacidadeInstalada" className="table table-bordered table-striped table-hover">
                        <thead>
                            <tr>
                                <th tyle={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Ano
                                    </center>

                                </th>
                                <th style={{ backgroundColor: '#bab6b6'}}> 

                                    <center>
                                    Cap. Instalada em FV (kWp)

                                    </center>

                                </th>
                               
                                <th style={{ backgroundColor: '#bab6b6'}}>
                                    <center>
                                    Cap. Instalada em Auto Geração Estacionária (kVA)
                                    </center>

                                </th>
                               
                                
                            </tr>
                            
                        </thead>
                        <tbody>
                            {tabelaCapacidadeInstalada}
                        </tbody>
                    </table>
                
                </div>

            

            <ModalEnergia adesao_institucional_id={adesao_institucional_id} ano={ano} fnEnergia={energia} />

        </div>
    )

}


export default TabelaGestao